<div [formGroup]="form" fxLayout="column">
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
    <mat-form-field>
      <input matInput formControlName="firstName" placeholder="First Name" required />
      <mat-error>First name is required</mat-error>
    </mat-form-field>
    <mat-form-field>
      <input matInput formControlName="middleName" placeholder="Middle Name" />
    </mat-form-field>
    <mat-form-field>
      <input matInput formControlName="lastName" placeholder="Last Name" required />
      <mat-error>Last name is required</mat-error>
    </mat-form-field>
    <mat-checkbox formControlName="hidden">Hide pilot?</mat-checkbox>
  </div>
  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field>
      <input
        matInput
        formControlName="certificateNumber"
        placeholder="Certificate Number"
        required
      />
      <mat-error>Certificate number is required</mat-error>
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field>
      <mat-label>Processing State</mat-label>
      <mat-select formControlName="processingState">
        <mat-option
          *ngFor="let option of processingStateOptions"
          [value]="option.value"
          [disabled]="!option.selectable"
        >
          {{ option.value | humanize }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
